import React, { Fragment, useCallback, useState } from 'react';
import { Input, Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Prompt } from 'react-router-dom';

const todayISO = () =>
    new Date()
        .toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' })
        .replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3');

const AddContactsNote2 = (props) => {
    const { addNote, activityList } = props;

    const [add, setAdd] = useState(false);
    const [date, setDate] = useState(todayISO());
    const [typeID, setTypeID] = useState(0);
    const [notes, setNotes] = useState('');
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    const handleSave = useCallback(() => {
        if (!addNote) return;

        addNote(date, typeID, notes, () => {
            setDate(todayISO());
            setTypeID(0);
            setNotes('');
            setAdd(false);
            setUnsavedChanges(false);
        });
    }, [addNote, date, typeID, notes]);

    return add ? (
        <>
            <Prompt
                when={unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />

            <Row className="mt-4">
                <Col className="pr-2">
                    <Input
                        type="date"
                        name="date"
                        value={date}
                        onChange={(e) => {
                            setDate(e.target.value);
                            setUnsavedChanges(true);
                        }}
                    />
                </Col>

                <Col className="pl-0">
                    <Fragment>
                        <Input
                            type="select"
                            name="typeID"
                            value={typeID}
                            onChange={(e) => {
                                setTypeID(parseInt(e.target.value, 10) || 0);
                                setUnsavedChanges(true);
                            }}
                        >
                            <option value="0">ACTIVITY</option>
                            {activityList
                                // .filter(item => item.longDescription !== 'Other')
                                .map(item => (
                                    <option key={item.ID} value={item.ID}>
                                        {item.longDescription}
                                    </option>
                                ))}
                        </Input>
                    </Fragment>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col>
                    <Input
                        type="textarea"
                        name="notes"
                        rows={15}
                        value={notes}
                        onChange={(e) => {
                            setNotes(e.target.value);
                            setUnsavedChanges(true);
                        }}
                    />
                </Col>
            </Row>

            <Row className="mt-2 text-right">
                <Col>
                    <Button color="success" onClick={handleSave}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <Button
                        color="secondary"
                        className="ml-2"
                        onClick={() => {
                            setAdd(false);
                            setUnsavedChanges(false);
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        </>
    ) : (
        <Row className="">
            <Col className='text-right'>
                <Button color="primary" onClick={() => setAdd(true)}>
                    Add Note
                </Button>
            </Col>
        </Row>
    );
};

export default AddContactsNote2;